export default __webpack_public_path__ + "static/media/2title.0559c747.jpg";